<script lang="ts">
import { createEventDispatcher } from "svelte";


    let fileinput, file, csv, message, validCsv, promise, data;
    export let username;

    const dispatcher = createEventDispatcher()

    function onUpload() {
        dispatcher("verifySession")
        file = fileinput.files[0]
        const reader = new FileReader()
        reader.addEventListener("load", () => {
            csv = reader.result
            validateCsv(csv)
        })
        reader.readAsText(file, "ISO-8859-1")
    }

    const validateCsv = (csv) => {
        let lines: Array<any> = csv.split('\n')
        message = ""
        let newCsv = []
        lines.forEach((element, index) => {
            let values: Array<string> = element.split(';')
            if(values.length == 5 && values[0] != "" && !isNaN(parseInt(values[0]))){
                newCsv.push(element)
            }else if(values.length < 5 && values.length != 1){
                console.log("Es wurden zu wenig Werte angegeben")
                message = "Es wurden zu wenig Werte angegeben"
                return false
            }else if(values.length > 5){
                console.log("Es wurden zu viele Werte angegeben")
                message = "Es wurden zu viele Werte angegeben"
                return false
            }
        })
        if(message !== ""){validCsv = false}else{validCsv = true; promise = fetchImpotCsv(newCsv)}
    }

    async function fetchImpotCsv(csv){
        dispatcher("verifySession")
        let res = await fetch("/pharmacy/importCsv", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({csv: csv, username: username})
        });
        data = await res.json()
    }

</script>

<div class="border-2 p-4 shadow">
    <div class="grid grid-cols-1 justify-items-start mb-5">
        <p class="font-bold mb-2">Beispiel CSV Format! :</p>
        <div class="border-l-4 border-yellow-500 rounded-r-lg shadow-xl bg-gray-100 p-3 grid grid-cols-1 mt-6 divide-y-2 divide-gray-200">
            <div class="grid grid-cols-5 bg-gray-200">
                <p class="p-1 font-bold">Apotheken-Nr.</p>
                <p class="p-1 font-bold">Apotheken-Name</p>
                <p class="p-1 font-bold">Straße und Hausnummer</p>
                <p class="p-1 font-bold">Postleitzahl und Ort</p>
                <p class="p-1 justify-self-center font-bold">Telefonnummer</p>
            </div>
            <div class="grid grid-cols-5 pt-3">
                <p class="p-1">295;</p>
                <p class="p-1">Sittig Apotheke Wolfen;</p>
                <p class="p-1">Fritz-Weineck-Str. 10;</p>
                <p class="p-1">06766 Wolfen;</p>
                <p class="p-1">Tel. 03494/44168</p>
            </div>
            <div class="grid grid-cols-5">
                <p class="p-1">284;</p>
                <p class="p-1">Adler-Apotheke Jeßnitz;</p>
                <p class="p-1">Hauptstr. 64;</p>
                <p class="p-1">06800 Jeßnitz;</p>
                <p class="p-1">Tel. 03494/72810</p>
            </div>
            <div class="grid grid-cols-5">
                <p class="p-1">823;</p>
                <p class="p-1">Nord-Apotheke Wolfen;</p>
                <p class="p-1">Commeniusstr. 34;</p>
                <p class="p-1">06766 Wolfen;</p>
                <p class="p-1">Tel. 03494/21045</p>    
            </div>
            <div>...</div>
        </div>
    </div>
    <div class="grid grid-cols-1 justify-self-stretch">
        {#if validCsv === false}
        <div class="border-l-4 border-red-500 rounded-r-lg shadow-xl bg-red-100 p-3 grid grid-cols-1 mt-6 justify-self-center mb-4">
            <strong class="text-red-500">Ein Fehler ist aufgetreten</strong>
            <p class="text-red-500">{message}</p>
        </div>
        {/if}
        {#if validCsv === true}
        {#await promise}
        <div></div>
        {:then}
        {#if data.imported}
        <div class="border-l-4 border-green-500 rounded-r-lg shadow-xl bg-green-100 p-3 grid grid-cols-1 mt-6 justify-self-center mb-4">
            <strong class="text-green-500">Erfolg!</strong>
            <p class="text-green-500">CSV wurde erfolgreich eingespielt!</p>
        </div>
        {/if}
        {#if data.message}
        <div class="border-l-4 border-red-500 rounded-r-lg shadow-xl bg-red-100 p-3 grid grid-cols-1 mt-6 justify-self-center mb-4">
            <strong class="text-red-500">Ein Fehler ist aufgetreten</strong>
            <p class="text-red-500">{data.message}</p>
        </div>
        {/if}
        {/await}
        {/if}
        <div class="border-none bg-blue-500 p-2 font-bold rounded shadow-xl select-none cursor-pointer w-auto h-auto text-white justify-self-center" on:click="{()=>{fileinput.click();}}">Upload</div>
            <input style="display:none;" type="file" bind:this="{fileinput}" on:input="{onUpload}">
    </div>
</div>






